<template>
  <v-client-table class="hiaTable" v-loading="loading" style="min-height: 200px;" element-loading-spinner="atom-audit-loader" :columns="['name', 'description', 'createdBy', 'createdDate']" :data="canvasList" :options="canvasListOptions">
    <template slot="createdDate" slot-scope="props">
      {{ props.row.createdDate ? format(parseISO(props.row.createdDate), 'MM/dd/yyyy hh:mm a') : '' }}
    </template>
    <template slot="name" slot-scope="props">
      <el-button type="text" @click="$emit('select', props.row)">{{ props.row.name }}</el-button>
    </template>
    <template slot="createdBy" slot-scope="props">
      {{ props.row.createdByDisplay }}
    </template>
  </v-client-table>
</template>

<script>
  import { parseISO, format } from 'date-fns'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'CanvasList',
    props: {},
    data() {
      return {
        parseISO,
        format,
        loading: false,
        canvasListOptions: {
          headings: {
            name: 'Name',
            description: 'Description',
            createdBy: 'Created By',
            createdDate: 'Created Date',
            project: 'Project',
            delete: ''
          }
        }
      }
    },
    mounted() {
      this.loadCanvasList()
    },
    methods: {
      ...mapActions('proReviews/canvas/', ['GET_CANVAS_LIST']),
      async loadCanvasList() {
        this.loading = true
        try {
          await this.GET_CANVAS_LIST()
        } catch (error) {
          this.$message.error('Failed to load canvas list: ' + error.message)
        } finally {
          this.loading = false
        }
      }
    },
    computed: {
      ...mapState('proReviews/canvas/', ['canvasList'])
    }
  }
</script>
